import React from 'react'

// import AlgoliaPartnersArticles from 'components/shared/AlgoliaPartnersArticles'
import TitleHero from 'components/slices/TitleHero'
import SliceManager from 'components/shared/SliceManager'
import CirclePictureContent from 'components/shared/CardWithArrowLink/CirclePictureContent'

import { getDataDependencies } from 'services/api'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import { algoliaIntegrationsAdapter } from 'adapters/integrations'
import algolia from 'src/services/algolia'
import AlgoliaSearch from 'components/shared/AlgoliaSearch'
import { fetchFacets } from 'src/services/algoliaHelpers'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'
import css from './styles.module.scss'

const index = 'integrations'
const Integrations = ({
  pageData: { intro, decoration, slices },
  articles,
  facets,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps

  return (
    <div className="container">
      {intro && <TitleHero {...intro} decoration={decoration} />}

      <AlgoliaSearch
        index={index}
        initialAlgolia={articles}
        adapter={algoliaIntegrationsAdapter}
        placeholder="Search an integration"
        labelType="Integrations"
        pathname="/integrations"
        facets={facets}
        fullSearch={false}
        customCardComponent={(props) => (
          <CirclePictureContent
            {...props}
            className={[
              css.integrationCard,
              props.level
                ? css[`integrationCard-${props?.level.toLowerCase()}`]
                : null,
            ]}
          />
        )}
        customCardProps={customCardProps}
        isAdvancedFilter
      />
      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

const integrationFacets = {
  integration_tags: {
    label: 'Integrations',
    multi: true,
  },
}

export async function getServerSideProps({ query, res }) {
  const articles = await algolia(index).search('', {
    hitsPerPage: 12,
    page: 0,
    filters: 'publishedAt:true',
  })

  const facets = await fetchFacets([index, integrationFacets])
  const pageData = await fetchSingleType('integrations-grid')
  const extendedData = await getDataDependencies(pageData)

  return {
    props: {
      pageData: extendedData,
      articles,
      facets,
    },
  }
}

export default Integrations
